import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  AuthService,
  CustomerService,
  GungFlow,
  GungFlowService,
  LocationConfigService,
  ProductGridCardV2Component
} from 'gung-standard';
import { first } from 'rxjs';

@Component({
  selector: 'cult-cult-product-grid-card-v2',
  templateUrl: './cult-product-grid-card-v2.component.html',
  styleUrls: ['./cult-product-grid-card-v2.component.scss']
})
export class CultProductGridCardV2Component extends ProductGridCardV2Component implements OnInit {
  isReturNoPrice = false;
  isReturnFlow = false;
  customerPriceList: string = '';

  constructor(
    protected authService: AuthService,
    protected gungFlowService: GungFlowService,
    protected router: Router,
    protected locationConfigService: LocationConfigService,
    protected customerService: CustomerService
  ) {
    super(router, locationConfigService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.authService
      .getCurrentUser()
      .pipe(first())
      .subscribe(user => {
        this.isReturNoPrice = user.roles.includes('RETUR_NOPRICE');
      });
    this.gungFlowService
      .getSelectedFlow()
      .pipe()
      .subscribe(flow => {
        if (flow.isReturnOrder) {
          this.isReturnFlow = true;
        }
      });

    const customerIdFromLocalstorage = localStorage.getItem('selectedCustomerId');

    if (customerIdFromLocalstorage) {
      this.customerService
        .getCustomer(customerIdFromLocalstorage)
        .pipe()
        .subscribe(customer => (this.customerPriceList = customer.extra.kus.prislista || ''));
    }
  }
}
